import {
    calcularQtdDependentesHumanos,
    calcularQtdDependentesEspeciaisHumanos,
    verificarParentescoForaDaEstruturaIlimitada
} from './funcoesAuxiliaresZP';

export class CorrenteEdicaoZP {
    constructor(
        dependentes,
        parentesco,
        categorias,
        valoresForm,
        valoresAnterioresForm
    ) {
        this.dependentes = dependentes;
        this.parentesco = parentesco;
        this.categorias = categorias;
        this.arrayMsgsErro = [];
        this.valoresForm = valoresForm;
        this.valoresAnterioresForm = valoresAnterioresForm;
    }
    
    infringeTipoDependente() {
        if (
            (this.valoresAnterioresForm.Parentesco.trim() === 'PET' &&
                this.valoresForm.Parentesco.trim() !== 'PET') ||
            (this.valoresAnterioresForm.Parentesco.trim() !== 'PET' &&
                this.valoresForm.Parentesco.trim() === 'PET')
        ) {
            this.arrayMsgsErro.push(
                'Não é possível alterar o tipo de dependente. Caso seja necessário, exclua e cadastre o dependente novamente com o tipo correto.'
            );
        }
        
        return this;
    }

    infringeAdicionalPet() {
        if (
            this.valoresForm.Parentesco.trim() === 'PET' && this.valoresForm.Categoria.trim() === 'ZELO'  
        ) {
            this.arrayMsgsErro.push(
                'Não é permitido dependente do tipo PET sem valor adicional.'
            );
        }

        return this;
    }

    infringeAdicionalPetPrime() {
        if (
            this.valoresForm.Parentesco.trim() !== 'PET' && this.valoresForm.Categoria.trim() === 'ZPETA'  
        ) {
            this.arrayMsgsErro.push(
                'O adicional ZELO PET PRIME é permitido apenas para dependentes do tipo PET.'
            );
        }

        return this;
    }

    infringeQuantidadeDependentesSemValorAdicional() {
        const qtdDependentesTotais = calcularQtdDependentesHumanos(this.dependentes);
        const qtdDependentesEspeciais = calcularQtdDependentesEspeciaisHumanos(this.dependentes);
        const qtdDependentesRegra  = qtdDependentesTotais - qtdDependentesEspeciais;
        const objDependenteSeraCadastrado = {
            'CategoriaParentesco.Categoria' : this.valoresForm.Categoria.trim(),
            'GrauParentesco.Grau' : this.valoresForm.Parentesco.trim()
        };
        const auxDep = [...this.dependentes,objDependenteSeraCadastrado];
        //'CategoriaParentesco.Categoria'].trim() === 'ZELO'  verificarParentescoNaoPermitido(dependente['GrauParentesco.Grau'].trim())
        
        if (verificarParentescoForaDaEstruturaIlimitada(auxDep) &&
            this.valoresForm.Parentesco.trim() !== 'PET' && qtdDependentesRegra >= 4) {
            this.arrayMsgsErro.push('Não é possível realizar a troca de adicional pois o número de dependentes sem valor adicional fora dos parentescos pai, mae, filho e conjuge seria maior que 4.');
        }

        return this;
    }

    infringeQuantidadeDependenteEspeciais() {
        const qtdDependentesEspeciais = calcularQtdDependentesEspeciaisHumanos(this.dependentes);

        if (qtdDependentesEspeciais === 1 &&
            this.valoresForm.Parentesco.trim() !== 'PET' &&
            (this.valoresAnterioresForm.Categoria === 'ZELO' && this.valoresForm.Categoria === 'ZP26')) {
            this.arrayMsgsErro.push('Este plano permite apenas 1 dependente especial HUMANO.');
        }

        return this;
    }
}
